import styled, { css, keyframes } from 'styled-components';

import { shade } from 'polished';
import { _DivProps } from 'styles/base';
interface AnimatedSpanProps extends _DivProps {
  $delay?: number;
  $duration?: number;
}

const appearFromLeft = keyframes`
  from{
    opacity: 0;
    transform: translateX(-150px);

  } to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

export const Menu = styled.div<_DivProps>`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  div + div {
    margin-top: 15px;
  }
`;

export const AnimatedDiv = styled.div<AnimatedSpanProps>`
  opacity: 0;
  transform: translateX(-150px);

  animation: ${appearFromLeft} ${({$duration}) => $duration || 1}s ease forwards;
  transition: all 0.5s;

  a,
  button {
    background: #fff;
    border-radius: 5px;
    border: 2px solid #efefef;
    padding: 5px 15px 5px 10px;
    box-shadow: 2px 5px 10px 0px rgba(0, 0, 0, 0.5);

    width: 100%;
    display: flex;
    align-items: center;

    text-decoration: none;

    transition: all 0.5s;
    svg {
      margin-right: 15px;
      color: #363636;
      transition: all 0.5s;
    }

    h3 {
      font-size: 18.72px;
      color: #767676;
      transition: all 0.5s;

      strong {
        color: ${shade(0.25, '#767676')};
        transition: all 0.5s;
      }
    }
  }

  ${({$delay}) =>
    $delay &&
    css`
      animation-delay: ${$delay}s;
    `}

  &:hover {
    a,
    button {
      transform: translateX(10px);
      box-shadow: 2px 5px 10px 3px rgba(0, 0, 0, 0.5);
      svg {
        color: #767676;
      }
      h3 {
        color: #332e2e;
        strong {
          color: ${shade(0.25, '#8a0002')};
        }
      }
    }
  }
`;

export const PrintContainer = styled.div<_DivProps>`
  min-height: 325px;
  &:first-child {
    margin-top: 0px;
  }

  span {
    > p {
      font-size: 16px;
      color: #8a0002;
      font-family: 'Roboto Slab', serif;
      font-weight: 500;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;

      strong {
        cursor: not-allowed;
        padding: 5px 10px;
        /* width: 50px; */

        background-color: #8a0002;
        border: 2px solid #8a0002;
        border-radius: 5px;

        color: #fff;

        &:hover {
          background-color: #6a0002;
          border-color: #6a0002;
          color: #fff;
        }
      }
    }
  }
`;
